import { ReactNode, useEffect, useState } from 'react';
import { RouteTrackerContext } from './context';
import { router } from '@Routes/__root';
import { reportPageViewed } from '@Services/analytics/GeneralAnalaytics.tsx';
import { getRouteByPath } from '@Router/router.consts.ts';
import { useBoundStore } from '@Store/useBoundStore.ts';
import { OnboardingFlowIdentifier, RouterData } from '@Types/onboarding.types.ts';

export const RouteTrackerProvider = ({ children }: { children: ReactNode }) => {
  const [prevRoute, setPrevRoute] = useState<string>('');
  const [currentRoute, setCurrentRoute] = useState<string>(router.state.location.pathname || '');
  const { setRouterData } = useBoundStore((state) => state.onboardingSlice);

  useEffect(() => {
    const unsub = router.subscribe('onResolved', (event) => {
      if (event.pathChanged) {
        const origin = event.fromLocation.pathname;
        const path = event.toLocation.pathname;
        const pathName = getRouteByPath(path)?.name || '';
        const searchParams = router.state.location.searchStr;

        setPrevRoute(origin);
        setCurrentRoute(path);
        const routerData: RouterData = { prevRoute: origin, currentRoute: path };

        setRouterData(routerData);
        const isAuthorizedUser =
          useBoundStore.getState().onboardingSlice.onboardingFlowIdentifier ===
          OnboardingFlowIdentifier.AUTHORIZED_USER;
        const authorizedUserType = useBoundStore.getState().authOnboardingSlice.authorizedUserType;
        reportPageViewed(
          origin,
          path,
          pathName,
          searchParams,
          isAuthorizedUser ? authorizedUserType : undefined
        );
      }
    });
    return () => {
      if (unsub) {
        unsub();
      }
    };
  }, []);
  return (
    <RouteTrackerContext.Provider value={{ prevRoute, currentRoute }}>
      {children}
    </RouteTrackerContext.Provider>
  );
};
